<template>
  <div class="wrap" :class="className">
    <div class="wrap_header">
      <div class="wrap_header_title" @click="clickTitle">
        <span>{{ title }}</span>
      </div>
      <div class="wrap_header_right">
        <el-tooltip class="item" effect="dark" :content="$t('web_app.homeNotice.messageClearAll')" placement="bottom">
          <span v-if="show_clearAll" @click="clearAll" class="clearAll">
            <svg-icon :iconClass="'clear'"></svg-icon>
          </span>
        </el-tooltip>

        <span v-if="show_fullscreen_button" @click="fullscreen">
          <svg-icon :iconClass="'fullscreen'"></svg-icon>
        </span>
        <span @click="close">
          <svg-icon :iconClass="'close'"></svg-icon>
        </span>
      </div>
    </div>
    <div class="wrap_content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeNoticeWrap',
  props: {
    title: {
      type: String,
      default: '',
    },
    closeClick: {
      type: Function,
      default: () => {},
    },
    titleClick: {
      type: Function,
      default: () => {},
    },
    show_fullscreen_button: {
      type: Boolean,
      default: false,
    },
    fullscreenClick: {
      type: Function,
      default: () => {},
    },
    className: {
      type: String,
      default: '',
    },
    show_clearAll: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('closeClick')
    },
    clickTitle() {
      this.$emit('titleClick')
    },
    fullscreen() {
      console.log('fullscreen')
      this.$emit('fullscreenClick')
    },
    clearAll() {
      this.$emit('clearAllClick')
    },
  },
}
</script>
<style lang="scss" scoped>
.wrap {
  padding: 6px 0;
  padding-bottom: 15px;
  margin: 10px 0;
  margin-bottom: 0px;
  background: var(--defaultBg) !important;
  width: 400px;
  box-sizing: border-box;
  //-webkit-backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
  //backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
  box-shadow: 0 0 20px var(--popoverShadow);
  border: 0.5px solid var(--fuzzy-border) !important;
  border-radius: 8px;
  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &_title {
      font-size: 16px;
      font-weight: 600;
      border-left: 4px solid var(--bgGreen);
      height: 16px;
      line-height: 16px;
      color: var(--bgGreen);
      span {
        margin-left: 16px;
      }
      &:hover {
        //text-decoration: underline;
        //text-underline-offset: 5px;
        cursor: pointer;
      }
    }
    &_right {
      cursor: pointer;
      padding: 0 11px;
      .clearAll {
        svg {
          width: 15px;
          height: 15px;
          padding: 7.5px;
        }
      }
      svg {
        width: 12px;
        height: 12px;
        padding: 9px;
        &:hover {
          background: var(--hoverBg);
          border-radius: 6px;
        }
      }
    }
  }
  &_content {
    padding: 10px;
    line-height: 21px;
    font-size: 14px;
    padding-bottom: 0px;
    position: relative;
  }
}
</style>
